const ValueType = {
    NONE: 'none',
    WRITTEN: 'written',
    SINGLE: 'single',
    MULTI: 'multi'
};

module.exports = ValueType;